import { ca } from '@cian/analytics';

interface IParams {
  newbuildingId: number;
  withRoomFilter: boolean;
}

export function trackClickLayoutsSeoLink({ newbuildingId, withRoomFilter }: IParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingLayout',
    action: 'click_sopr',
    label: withRoomFilter ? 'layout_seo_url_room_cnt' : 'layout_seo_url',
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
  });
}
